import React, { useState, useCallback, useRef } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Grid , CircularProgress, Box } from '@material-ui/core';
import { ItemsListViewProps, isOrder } from './types';
import { PlainLink } from '../../../../ui-kit';
import Bill from '../../../billManagement/components/Bill/Bill';
import Order from '../../../orders/components/Order/Order';
import { useIntersectionObserver } from '../../../../utils';

const LoadMoreElement: React.FC<{ isLoading: boolean; ref: React.Ref<HTMLDivElement> }> = React.forwardRef(({
    isLoading
}, ref) => (
    <div ref={ref}>
        <Box display='flex' flexGrow={1} justifyContent='center'>
            {isLoading ? <CircularProgress /> : null}
        </Box>
    </div>
));

const ItemsListView = ({ items, loadMore, hasMore }: ItemsListViewProps) => {
    const { url } = useRouteMatch();
    const [ isLoading, setIsLoading] = useState(false);
    
    const load = useCallback(async () => {
        setIsLoading(true);
        await loadMore();
        setIsLoading(false);
    }, [loadMore]);

    const loaderRef = useRef<HTMLDivElement>(null);

    const onLoadMore: IntersectionObserverCallback = useCallback(async entries => {
        const target = entries[0];
        if(target.isIntersecting && hasMore && !isLoading){
            await load();
        }
    }, [load, isLoading, hasMore]);

    useIntersectionObserver(loaderRef, onLoadMore);
   
    const shouldShowLoadMore = items.length > 0 && hasMore;
    return (
        <Grid container spacing={3}>
            {items.map(item => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                    <PlainLink to={`${url}/${item.id}`}>
                        {isOrder(item) ? <Order order={item} /> : <Bill bill={item} />}
                    </PlainLink>
                </Grid>
            ))}
            <Grid item xs={12}>
                {shouldShowLoadMore ? <LoadMoreElement ref={loaderRef} isLoading={isLoading} /> : null}
            </Grid>
        </Grid>
    );
};

export default ItemsListView;
